<microempresario-header></microempresario-header>
<div class="body" style="color: #333">
  <div class="title_section my-2 my-xl-3">Ofertas realizadas por Aliados</div>
  <div id="wrappeed_ofertas" class="container">
    @if (propuestas.length !== 0) {
      <div class="row">
        @for (propuesta of propuestas; track propuesta) {
          <div
            class="col-12 col-xl-6 mb-3 my-xl-3"
            >
            <div class="card">
              <div class="card-header">
                {{ propuesta.nombreIntermediario }}
              </div>
              <div class="card-body">
                <div class="card-text">
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">Monto:</div>
                    <div class="col-12 col-xl-6">
                      {{ propuesta.monto | currency: "USD" }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">Tasa:</div>
                    <div class="col-12 col-xl-6">
                      {{ propuesta.tasa + " %" }} E.A.
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">Plazo:</div>
                    <div class="col-12 col-xl-6">{{ propuesta.plazo }} meses</div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">
                      Período de gracia:
                    </div>
                    <div class="col-12 col-xl-6">
                      {{ propuesta.periodoGracia }} meses
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">Forma de pago:</div>
                    <div class="col-12 col-xl-6">
                      {{ propuesta.nombrePeriodicidad }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">
                      Valor neto a desembolsar:
                    </div>
                    <div class="col-12 col-xl-6">
                      {{ propuesta.desembolsoAproximado | currency: "USD" }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-xl-6 textsubtitle">
                      Cuota aproximada a pagar:
                    </div>
                    <div class="col-12 col-xl-6">
                      {{ propuesta.cuota | currency: "USD" }}
                    </div>
                  </div>
                  <div class="row subtitlebakground mt-3">
                    <div class="col-12 subtitle">Garantías requeridas para el otorgamiento del crédito y cargos considerados</div>
                  </div>
                  <div class="mb-3">
                    @if (propuesta.neoCargoComisiones) {
                      <div>
                        @for (cargo of propuesta.neoCargoComisiones; track cargo) {
                          <div>
                            <div class="row subtitlebakground_2">
                              <div class="col-12 col-xl-4">{{ cargo.tipoCargo }}</div>
                              <div class="col-12 col-xl-4">{{ cargo.descripcion }}</div>
                              <div class="col-12 col-xl-4">
                                {{ cargo.monto | currency: "USD" }}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div class="row subtitlebakground_2">
                      <div class="col-12">
                        {{
                        propuesta.neoCargoComisiones.length < 1 ? "Ninguno" : ""
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="row subtitlebakground mt-3">
                    <div class="col-12 subtitle">Observaciones</div>
                  </div>
                  <div class="row subtitlebakground_2 mb-3">
                    <div class="col-12">
                      {{ propuesta.observacionesAprobador }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <input
                  class="propuestaRadio"
                  type="radio"
                  name="idPropuesta"
                  (click)="seleccionarPropuesta(propuesta.idPropuesta)"
                  />
                  <label class="ms-3" for="#propuestasbtn">
                    Seleccionar esta propuesta
                  </label>
                </div>
              </div>
            </div>
          }
          <div class="col-12 mt-3">
            <div class="backgroundNinguna rounded pt-2">
              <input
                class="propuestaRadio"
                type="radio"
                name="idPropuesta"
                (click)="selectPropuesta('0')"
                />
                <label class="ms-3" for="#propuestasbtn">
                  No deseo seleccionar ninguna oferta
                </label>
              </div>
            </div>
          </div>
        } @else {
          <div class="container-fluid text-center text-light">
            No hay ofertas para esta solicitud
          </div>
        }
        @if (idPropuesta === '0') {
          <div class="row mt-2">
            <div class="col-12">
              <div class="mb-3 form-label">
                <label for="motivos" class="form-label">Motivo del rechazo</label>
                <select class="form-control" [(ngModel)]="idNegacion" (change)="validarNegacion()">
                  <option value='0'>Seleccione...</option>
                  @for (negacion of negaciones; track negacion) {
                    <option
                      [value]="negacion.idTipoNegacionPropuestas"
                      >
                      {{ negacion.nombre }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-6" [hidden]="idNegacion != 2">
              <div class="mb-3 form-label">
                <label for="condicionesFinancieras" class="form-label">Condiciones financieras*</label>
                <select class="form-control selectpicker" data-live-search="true"
                  data-size="4" multiple [(ngModel)]="configuracionCondicionesFinancieras"
                  title="Seleccione opción" data-actions-box="true" data-select-all-text="<i class='fas fa-plus'></i> Seleccionar todos"
                  data-deselect-all-text="<i class='fas fa-minus'></i> Eliminar todos">
                  @for (tipo of listCondiciones; track tipo) {
                    <option [value]="tipo.idCondicionesFinancieras">
                      {{ tipo.nombre }}
                    </option>
                  }
                </select>
              </div>
            </div>
            @if (idNegacion == 4) {
              <div class="col-12 mb-5">
                <div class="mb-3 form-label">
                  <label for="detalle" class="form-label">Detalle</label>
                  <textarea
                    cols="30"
                    maxlength="1000"
                    rows="4"
                    class="form-control"
                    style="resize: none"
                    [(ngModel)]="detalle"
                    >
                  </textarea>
                </div>
              </div>
            }
          </div>
        }
        <!-- Inicio CRUD ARCHIVOS -->
        @if (idPropuesta && idSegmento) {
          <div id="documentos_segmentos" class="container">
            <div>
              <!-- Mensaje de autorización de datos -->
              <div class="hr bgc-warning" style="color: #ffffff">
                Para la formalización del Crédito con el Aliado Financiero será necesario realizar la Autorización de
                Uso de Datos de Bancóldex, por favor diligenciarla en el siguiente
                <a style="color: #00e5be; cursor: pointer;" (click)="_modal.enlaceModal('https://vinculacion.bancoldex.com/datospersonales/#/')"
                title="Seguir enlace" class="btn-link">link</a>.
              </div>
            </div>
            @if (tiposDocumentos?.length > 0) {
              <div class="row">
                <div class="col-12 hr bg-green text-center rounded">ARCHIVOS ADICIONALES</div>
              </div>
            }
            @if (tiposDocumentos?.length > 0) {
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-sx-12">
                  @for (documento of tiposDocumentos; track documento; let i = $index) {
                    <div>
                      <div class="card text-start">
                        <span>
                          {{i+1}}. {{ documento.segTipoDocumento.nombre | uppercase}}{{documento.obligatorio === false?' (Opcional)':' *'}}
                          @for (guias of documento.segTipoDocumento.segDocumentoGuias; track guias; let i = $index) {
                            <span>
                              @if (guias.estado ==='HABILITADO') {
                                <span>
                                  <!-- Extensión xls y xlsx -->
                                  @if (guias.extension === 'xlsx' || guias.extension === 'xls') {
                                    <a class="fas IcoFormSmall fa-file-excel text-success ms-3"
                                    title="Descargar guía" (click)="_modal.descargarGuiaModal(guias?.archivo, guias?.nombre ,guias?.tipoContenido)"></a>
                                  }
                                  <!-- Extensión pdf -->
                                  @if (guias.extension === 'pdf') {
                                    <a class="fas IcoFormSmall fa-file-pdf text-danger ms-3" title="Descargar guía"
                                    (click)="_modal.descargarGuiaModal(guias.archivo, guias.nombre ,guias.tipoContenido)"></a>
                                  }
                                  <!-- Extensión docx y doc -->
                                  @if (guias.extension === 'docx' || guias.extension === 'doc') {
                                    <a class="fas IcoFormSmall fa-file-word text-info ms-3" title="Descargar guía"
                                    (click)="_modal.descargarGuiaModal(guias.archivo, guias.nombre ,guias.tipoContenido)"></a>
                                  }
                                  @if (guias.guia != null) {
                                    <span placement="top"
                                          class="ms-3"
                                          tooltipClass="stylesToll"
                                          style="cursor: pointer;"
                                          container="body"
                                          [openDelay]="500"
                                          [ngbTooltip]="guias.guia">
                                      <i class="far fa-question-circle"></i></span>
                                    }
                                  </span>
                                }
                              </span>
                            }
                          </span>
                          @if (documento.estado == 'HABILITADO') {
                            <div class="controls">
                              <div [value]="documento.id">
                                <button [disabled]="isDocumento(documento.id)" title="Cargar documento" (click)="fileInput.click()"
                                  class="IcoForm">
                                  <span class="material-icons" style="color: #00E5BE;">
                                    drive_folder_upload
                                  </span>
                                </button>
                                <button [disabled]="!isDocumento(documento.id)" title="Ver documento"
                                  (click)="seeDocument(documento.id)"
                                  class="IcoForm">
                                  <span class="material-icons-outlined" style="color: #4d4b78;">
                                    visibility
                                  </span>
                                </button>
                                <button title="Eliminar documento" [disabled]="!isDocumento(documento.id)"
                                  (click)="deleteFile(documento.id)" class="IcoForm ">
                                  <span class="material-icons-outlined text-danger">
                                    delete
                                  </span>
                                </button>
                              </div>
                              <input #fileInput type="file" [accept]="getAcceptExtensions(documento.segTipoDocumento.segTipoDocExtensions)" hidden (click)="(fileInput.value = null)"
                                (change)="saveFile($event, documento)" />
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <div class="mt-2" >
      <button [disabled]="(!(idPropuesta=='0') && !idPropuesta) || ((idPropuesta=='0') && !(idNegacion!=0))
        || (!(idNegacion != 2) && (configuracionCondicionesFinancieras.length == 0))" (click)="elegirOferta()"
                class="btn btn-primary me-3">
                {{ idPropuesta === '0'?"Finalizar":"Elegir oferta" }}
              </button>
              <button routerLink="/microempresario/home" class="btn btn-primary">
                Cancelar
              </button>
            </div>
          </div>
          <div class="footer-body"></div>
        </div>
        <app-footer></app-footer>
        <!-- Modal -->
        <div class="modal fade text-center" id="seleccionarPropuesta" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="seleccionarPropuesta">SELECCIONAR PROPUESTA</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="selectPropuesta(null)" aria-label="Close">

                </button>
              </div>
              <div class="modal-body justify-content-md-center">
                <div class="row">
                  <div class="col-12 col-sm-12">
                    <h5 style="color: black;">{{mensajeSeleccion}}</h5>
                  </div>
                </div>
              </div>
              <div class="modal-footer justify-content-md-center">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="selectPropuesta(idPropuestaSelect)" >Aceptar</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="selectPropuesta(null)">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <div class="modal fade text-center" id="elegirOferta" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="elegirOferta">ELEGIR OFERTA</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                </button>
              </div>
              <div class="modal-body justify-content-md-center">
                <div class="row">
                  <div class="col-12 col-sm-12">
                    <h5 style="color: black;">{{mensajeElegir}}</h5>
                  </div>
                </div>
              </div>
              <div class="modal-footer justify-content-md-center g-3">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="savePropuesta()">Aceptar</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
        <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
